import { render, staticRenderFns } from "./FormTemplateDialog.vue?vue&type=template&id=018f5962&"
import script from "./FormTemplateDialog.vue?vue&type=script&lang=ts&"
export * from "./FormTemplateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports